import beautify from "js-beautify";
import React, { useState } from "react";
import CodeSlides from "./CodeSlides";

// Function to check if input is valid HTML
function isValidHTML(str) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
}

function HtmlMinifierFormatter() {
  const [input, setInput] = useState("");
  const [output, setOutput] = useState("");
  const [error, setError] = useState("");

  const handleBeautify = () => {
    if (!isValidHTML(input)) {
      setError("Please paste valid HTML code.");
      setOutput("");
      return;
    }
    setError("");
    const formatted = beautify.html(input, {
      indent_size: 2,
      preserve_newlines: true,
    });
    setOutput(formatted);
  };

  const handleMinify = () => {
    if (!isValidHTML(input)) {
      setError("Please paste valid HTML code.");
      setOutput("");
      return;
    }
    setError("");
  
    // Minify HTML while keeping line breaks
    const minified = input
      .split("\n")                                // split into lines
      .map(line => line.trim())                   // trim each line
      .filter(line => line !== "")                // remove empty lines
      .join("\n");                                // rejoin with line breaks
  
    setOutput(minified);
  };
  

  return (
    <>
    <section className="section-padding">
      <div className="container">
        <div className="text-center">
          <div className="section-title text-gradient">HTML Minifier & Formatter</div>
          <div className="section-subTitle padd-title">
            Use this tool to format or minify your HTML code.
          </div>
        </div>

        <div className="input-btn-grp pt-5">
          <div className="row">
            <div className="col-lg-6 my-3">
              <div className="input-group">
                <textarea
                  className="form-control"
                  rows={15}
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  placeholder="Paste your HTML here..."
                />
              </div>
              {error && (
                <div className="text-danger mt-2" style={{ fontSize: "0.9rem" }}>
                  {error}
                </div>
              )}
            </div>

            <div className="col-lg-6 my-3">
              <div className="input-group">
                <textarea
                  className="form-control"
                  rows={15}
                  value={output}
                  readOnly
                  placeholder="Result will appear here..."
                />
              </div>
            </div>
          </div>
        </div>

        <div className="btn-alert-grp mt-3">
          <button
            onClick={handleBeautify}
            className="clear-btn "
          >
            Beautify
          </button>
          <button
            onClick={handleMinify}
            className="clear-btn "
          >
            Minify
          </button>
        </div>
      </div>
    </section>
    <section className="section-padding">
      <div className="container">
    <h3 className="text-section-title"> Related Tools </h3>
      <CodeSlides/>
      </div>
    </section>
    </>
  );
}

export default HtmlMinifierFormatter;
